import { useEffect, useState } from "react";
import { trackEvent, updateGtagConsent } from "~/lib/gtag";

type ConsentStatus = "accepted" | "rejected" | "pending";
const STORAGE_KEY = "firmindex_cookie_consent";

export function useCookieConsent() {
	const [consent, setConsent] = useState<ConsentStatus>("pending");
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored === "accepted" || stored === "rejected") {
			setConsent(stored);
			updateGtagConsent(stored === "accepted");
		}
	}, []);

	const accept = () => {
		localStorage.setItem(STORAGE_KEY, "accepted");
		setConsent("accepted");
		updateGtagConsent(true);
		// Send initial page_view now that consent is granted
		trackEvent("page_view", {
			page_location: window.location.href,
			page_title: document.title,
		});
	};

	const reject = () => {
		localStorage.setItem(STORAGE_KEY, "rejected");
		setConsent("rejected");
		updateGtagConsent(false);
	};

	return { consent, accept, reject, mounted };
}
